import React, { Component } from "react";
import { view } from "react-easy-state";
import testShader from "../shaders/testShader.js";
import glfunc from "../glfunc.js";
import css from "./StrokePreview.module.css";

const vec2 = window.vec2;

class StrokePreview extends Component {
  state = {
    gl: null,
    lastDrawPos: [0, 0]
  };
  componentDidMount() {
    let gl = this.refs.canvas.getContext("webgl", {
      preserveDrawingBuffer: true
    });

    glfunc.createUnitQuad(gl);
    glfunc.createBrushProgram(gl, testShader);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

    this.setState({ gl: gl });
  }

  // not sure why this is needed anymore.  It's thowing a warning, so I'm
  // going to comment it out until I remember why it was needed ;)
  // componentWillReceiveProps(nextProps) {
  //   this.updateCanvas(this.getBrush(this.props));
  // }

  updateCanvas(brush) {
    let gl = this.state.gl;
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    // glfunc.updateCanvas(gl, 128, 32, brush, [255, 255, 255]);
    this.stroke(brush);
  }

  stroke(brush) {
    let width = this.state.gl.drawingBufferWidth;
    let height = this.state.gl.drawingBufferHeight;
    let padding = 12;

    let posx = 0;
    let posy = height / 2;
    let lastDrawPos = [posx, posy];
    let oldFlow = brush.flow / 100;
    let oldSize = brush.size;

    for (posx = 0; posx < width - 2 * padding; posx++) {
      posy =
        -Math.sin((posx / (width - 2 * padding)) * 360 * (Math.PI / 180)) *
          Math.min(height / 4, 24) +
        height / 2;
      let dynamicSize = brush.sizeControl
        ? Math.sin((posx / (width - 2 * padding)) * 180 * (Math.PI / 180))
        : 1;
      let thisSize = Math.min(oldSize, height / 2);
      brush.size = Math.max(thisSize * dynamicSize, 2);
      if (brush.flowControl) {
        brush.flow =
          oldFlow *
          (100 *
            Math.sin((posx / (width - 2 * padding)) * 180 * (Math.PI / 180)));
      }
      let spacing =
        brush.size * (brush.roundness / 100) * (brush.spacing / 100);
      if (spacing < 1) spacing = 1;

      let distance = Math.hypot(posx - lastDrawPos[0], posy - lastDrawPos[1]);

      if (distance > spacing) {
        let endPos = [posx, posy];

        let deltaVector = [posx - lastDrawPos[0], posy - lastDrawPos[1]];
        vec2.normalize(deltaVector, deltaVector);
        vec2.scale(deltaVector, deltaVector, spacing);

        while (vec2.distance(lastDrawPos, endPos) > spacing) {
          vec2.add(lastDrawPos, lastDrawPos, deltaVector);

          glfunc.updateCanvas(
            this.state.gl,
            lastDrawPos[0] + padding,
            lastDrawPos[1],
            brush,
            [255, 255, 255]
          );
        }
      }
    }
  }

  getBrush(props) {
    let brush = Object.assign({}, props.brush);
    return brush;
  }

  render() {
    if (this.state.gl) {
      this.updateCanvas(this.getBrush(this.props));
    }

    return (
      <div className={css.brushPreview}>
        <canvas width="256" height="100" className={css.canvas} ref="canvas" />
        {/* <div>{JSON.stringify(store.brush)}</div> */}
      </div>
    );
  }
}

export default view(StrokePreview);
